import { Avatar, Grid, Typography } from "@mui/material";

import { FONT_SECONDARY } from "@/theme/typography";
import sparkles_iconUrl from "@/assets/icons/about-us/sparkles.svg";
import ResourcesCard from "./ResourcesCard";
import { showcase } from "@/utils/staticData/showcase";

const InquiriesShowcase = () => {
  return (
    <>
      <Typography
        variant="caption"
        display="flex"
        fontFamily={FONT_SECONDARY}
        mb={{ xs: 1.5, md: 3.5 }}
        gap={1}
        alignItems="center"
        sx={{ width: "100%" }}
        justifyContent="start"
        pl={{ xs: 3 }}
      >
        <Avatar
          src={sparkles_iconUrl}
          sx={{
            width: { xs: 10, md: 20 },
            height: { xs: 10, md: 20 },
          }}
        />
        We’ll gladly send you free trackers!
      </Typography>
      <Grid container spacing={{ xs: 2, md: 3 }}>
        {showcase.map(({ name, image }, index) => (
          <Grid item xs={4} key={index}>
            <ResourcesCard title={name} imageUrl={image} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default InquiriesShowcase;
